"use client";

import React from "react";
import { Stack } from "@mui/material";
import { useProductPageContext } from "../Providers/useProductPageContext";
import { VariantAttributeSelector } from "./VariantAttributeSelector";

/** Variant pickers that sit under the product title, separate from the buy box. */
export default function ProductVariantPickers() {
  const context = useProductPageContext();
  const groups = context?.attributeGroups ?? [];

  if (!context || !context.anyVariantAvailableToSell || groups.length === 0) return null;

  return (
    <Stack id="variant-pickers" component="section" aria-label="انتخاب تنوع" spacing={1.5} sx={{ minWidth: 0, scrollMarginTop: { xs: 96, md: 140 } }}>
      {groups.map((group) => (
        <VariantAttributeSelector
          key={group.name}
          name={group.name}
          values={group.values}
          selected={context.selectedAttrs[group.name]}
          prompted={context.promptedAttrs.includes(group.name)}
          onSelect={(value) => context.selectAttribute(group.name, value)}
        />
      ))}
    </Stack>
  );
}
